import React, { useContext} from 'react'
import PropTypes from 'prop-types';
import { Link } from 'gatsby'
import HouseIcon from 'images/icons/house.inline.svg';
import useWindowSize from 'hooks/useWindowSize';
import { LUCIDWORKS_PLATFORM_TAG } from 'config/productItems';
import { BreadcrumbsContext, initialBreadcrumbsState } from 'context/breadcrumbsContextWrapper';
import DropdownMenu from 'components/Dropdown/Dropdown.component';
import { breadcrumb, houseLink } from './breadcrumb.module.scss';


const Breadcrumbs = ({ 
        title = '',
        currentProductValue,
        currentProductLink,
        isHowTo,
        basePath,
        path = '/'
    }) => { 

        const state = useContext(BreadcrumbsContext) || initialBreadcrumbsState

        const {width} = useWindowSize();


        const breadcrumbsSet = new Set([...state.breadcrumbsPath])
        const breadcrumbsArray = [...breadcrumbsSet]

        const isDeepNestedPath = breadcrumbsArray?.length > 4

        const isHome = path === '/' || path === '/*'
        const isSearch = basePath === 'search'
        const isPolicy = basePath === 'policies'

        const isLucidworksPlatform = basePath === LUCIDWORKS_PLATFORM_TAG

        return ( 
                <aside className={breadcrumb} style={{
                        paddingTop: `${isDeepNestedPath ? '0' : '0.5em'}`,
                        paddingBottom: `${isDeepNestedPath ? '0' : '0.5em'}`
                    }}
                >
                    <span style={{display: 'flex', alignItems: 'center'}}><Link to="/" className={houseLink}><HouseIcon /></Link>/&nbsp;&nbsp;&nbsp;</span>
                        
                    <span style={{display: 'flex', alignItems: 'center'}}>
                        {isHome ? '': null}
                        {!isHome && isHowTo ? <Link to='/how-to'>How-to</Link> : null}
                        {!isHome && isPolicy ? <Link to="/policies/200/policies">Policies</Link> : null}
                        {!isHome && isSearch ? <Link to="/search?sort=&start=0&rows=10&q=*%3A*">Search</Link> : null}
                        {!isHome && !isHowTo && !isSearch && !isPolicy ? 
                                <Link to={currentProductLink} style={{textTransform:'capitalize'}}>
                                    { isLucidworksPlatform ? "Lucidworks Platform" : currentProductValue }
                                </Link> 
                            : 
                                null
                        }                    
                    </span>
                    
                    {
                        isDeepNestedPath || width < 990 ?
                            <>
                                {
                                    breadcrumbsArray.length > 0 && <span>
                                        <span>&nbsp; / &nbsp;</span>
                                        <DropdownMenu menuItems={breadcrumbsArray.slice(1)}/>
                                        <span>&nbsp; / &nbsp;{title}</span>
                                    </span>
                                }
                            </>
                        :
                            <>
                                { breadcrumbsArray?.reverse()?.map((item, indx) =>{
                                    const itemSplit = item.split('==')
                                    const name = itemSplit[0]
                                    const link = itemSplit[1]
                                    if(isPolicy && indx === 0){
                                        return <></>
                                    }
                                    return (
                                        <span key={item} style={{marginLeft: '0.5rem', display: 'flex', alignItems: 'center'}}>
                                            {indx <= breadcrumbsArray.length - 1 && <>/ &nbsp;</>}
                                            <Link to={`/${link}`}>{name}</Link>
                                        </span>
                                    )
                                })}
                            </>
                    }

                </aside>
        )
}

Breadcrumbs.propTypes = {
    title: PropTypes.string,
    currentProductValue: PropTypes.string.isRequired,
    currentProductLink: PropTypes.string.isRequired,
    isHowTo: PropTypes.bool.isRequired,
    basePath: PropTypes.string.isRequired,
    path: PropTypes.string
}

export default Breadcrumbs;